"use client";

import Link from "next/link";
import { Plus, ArrowUpRight } from "lucide-react";
import TextGenerateEffect from "@/components/TextGenerateEffect";
import BLOG_POSTS from "@/app/blog/data";

/**
 * Homepage blog teaser — Apple/fabrica-style layout with two small
 * article cards on the left and one large feature card on the right.
 * Links through to /blog and individual post pages.
 */
export default function HomeBlogSection() {
  // Newest two posts as small cards; newest overall as the feature card.
  const [featured, ...rest] = BLOG_POSTS;
  const smallCards = rest.slice(0, 2);

  return (
    <section id="journal" className="hb-section">
      <div className="hb-inner">
      <div className="hb-head">
        <div className="hb-head-title">
          <TextGenerateEffect
            as="h2"
            words="Latest stories **and updates.**"
            className="hb-headline"
            duration={0.8}
            staggerDelay={0.05}
            filter={false}
            highlightColor="#6e6e73"
          />
        </div>
        <div className="hb-head-sub">
          <p>
            Stay current on championships, media features, and the craft
            behind world-class spine surgery.
          </p>
        </div>
        <Link href="/blog" className="hb-seeall">
          <span>See all</span>
          <span className="hb-seeall-dot" aria-hidden />
        </Link>
      </div>

      <div className="hb-grid">
        {smallCards.map((post) => (
          <Link
            key={post.slug}
            href={`/blog/${post.slug}`}
            className="hb-card hb-card--small"
          >
            <div className="hb-card-thumb">
              <img src={post.image} alt="" />
            </div>
            <button type="button" className="hb-card-plus" aria-hidden tabIndex={-1}>
              <Plus size={16} strokeWidth={2.5} />
            </button>
            <div className="hb-card-body">
              <div className="hb-card-date">{post.dateLabel}</div>
              <h3 className="hb-card-title">{post.title}</h3>
              <p className="hb-card-excerpt">{post.excerpt}</p>
            </div>
          </Link>
        ))}

        <Link
          href={`/blog/${featured.slug}`}
          className="hb-card hb-card--feature"
        >
          <div className="hb-card-bg">
            <img src={featured.image} alt="" />
            <div className="hb-card-bg-overlay" />
          </div>
          <div className="hb-feature-brand">Burak Ozgur, MD</div>
          <button type="button" className="hb-card-plus hb-card-plus--light" aria-hidden tabIndex={-1}>
            <Plus size={16} strokeWidth={2.5} />
          </button>
          <div className="hb-feature-foot">
            <div className="hb-feature-date">{featured.dateLabel}</div>
            <h3 className="hb-feature-title">{featured.title}</h3>
            <span className="hb-feature-cta">
              Read story <ArrowUpRight size={16} strokeWidth={2} />
            </span>
          </div>
        </Link>
      </div>
      </div>
    </section>
  );
}
